import * as React from 'react'
import { lang } from 'utils/helpers'
import usePluginTopicSummary from './usePluginTopicSummary'
import CollapsablePlugin from 'components/common/CollapsablePlugin'
import Nixi1Spinner from 'components/Nixi1Spinner'
import './styles.scss'
import { Button } from 'reactstrap'
import { getStaticImage } from 'utils/statics'
import withModule from 'hocs/withModule'

/**
 * PluginTopicSummary
 * @param {boolean} isRemoveByUser - state to control the remove by user
 */
const PluginTopicSummary = (props) => {
  const { isRemoveByUser } = props
  const { isLoading, isOpen, topics, toggleCard, onGenerateClick } = usePluginTopicSummary()

  return (
    <CollapsablePlugin
      isOpen={isOpen}
      onClickCollapse={toggleCard}
      disabled={isRemoveByUser}
      title={lang('dashboard_topic_summary')}
      icon={"icon-topic-summary"}
    >
      <div className='plugin-topic-summary__container'>
        <div className='plugin-topic-summary__separator'></div>
        {
          isLoading ? (
            <div className="plugin-topic-summary__loading">
              <Nixi1Spinner width='15px' height='15px' />
            </div>
          ) : (
            <>
              {
                topics?.length > 0 && topics.map((topic, index) => {
                  return (
                    <div key={index} className='plugin-topic-summary__topic'>
                      <div className='plugin-topic-summary__topic--title'>
                        <span>{lang('dashboard_topic')}: </span>{topic.topic}
                      </div>
                      <div className='plugin-topic-summary__topic--content'>
                        <div className='plugin-topic-summary__topic--content--title'>
                          <figure>
                            <img src={getStaticImage(`/icons/orange-brand/icon-topic-list.svg`)} alt={`icon-topic-list`} />
                          </figure>
                          <span>{lang("dashboard_summary")}:</span>
                        </div>
                        <p>{topic.summary}</p>
                      </div>
                    </div>
                  )
                })
              }
              <div className='plugin-topic-summary__container--center'>
                <Button color='primary' onClick={onGenerateClick}>
                  {
                    topics.length > 0 ?
                      lang('dashboard_topic_summary_update_button') :
                      lang('dashboard_topic_summary_generate_button')
                  }
                </Button>
              </div>
            </>
          )
        }
      </div>
    </CollapsablePlugin>
  )
}

export default withModule(PluginTopicSummary, 'topic')
